; (function (inovestor, undefined) {
    // Setup dependencies for this plugin
    // Normally we would add jQuery and knockout but ms-core, which we depend on, already register them so it's useless

    // Create plugin namespace with any desired config variable
    inovestor.ms.stock = inovestor.ms.stock || {};
})(inovestor);


; (function (stock, undefined) {
    // Create plugin namespace with any desired config variable
    stock.profile = {
        config: {
            apiRelativeUrl: 'stocks/companyprofile?symbol={symbol}'
        }
    };

})(inovestor.ms.stock);


; (function ($, ko, inovestor, undefined) {
    
    inovestor.ms.stock.profile.viewModels = {};

    inovestor.ms.stock.profile.viewModels.profileViewModel = function () {
        var self = this;

        self.profile = ko.observable();
        self.resources = ko.observable();
        self.hasError = ko.observable(false);
        self.isInvalidIdentifier = ko.observable(false);
        self.hasValidData = ko.computed(function () {
            return !self.hasError() && !self.isInvalidIdentifier() && self.profile() != null;
        }, this);

        self.chosenYear = ko.observable();

        self.updateResources = function () {
            // Update main resources
            var currentResource = inovestor.ms.stock.profile.resources[inovestor.ms.core.currentLanguage];
            if (inovestor.ms.core.isNullOrUndefined(currentResource))
                currentResource = null;
            self.resources(currentResource);
        };
    }

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, ko, inovestor, undefined) {

    var pluginName = 'inoMsStockProfile';

    // Create the plugin constructor
    function Plugin(element, options) {

        this.element = element;
        this._name = pluginName;
        this._defaults = $.fn.inoMsStockProfile.defaults;
        this._viewModel = new inovestor.ms.stock.profile.viewModels.profileViewModel();

        // Merge options with defaults
        this.options = $.extend({}, this._defaults, options);

        // Make sure required variables are set
        if (inovestor.ms.core.isNullOrUndefined(this.options.symbol))
            throw "symbol is required";

        // Call init
        this.init();
    }

    $.extend(Plugin.prototype, {

        // Initialization logic
        init: function () {
            var plugin = this;

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                plugin.update();
            });

            // Plugin overrides for template = cacheKey and path are the same
            var fileCacheKey = plugin.options.templatePaths.profile;
            var filePath = plugin.options.templatePaths.profile;
            // Default behavior (if no template path is set by plugin)
            if (inovestor.ms.core.isEmptyString(fileCacheKey)) {
                var fileName = 'profile.html';
                fileCacheKey = pluginName + '.' + fileName;
                filePath = (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) ? '' : inovestor.ms.core.config.templateRootUrl) +
                    (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) || inovestor.ms.core.config.templateRootUrl.match(/\/$/) != null ? '' : '/') + // check if templateRootUrl ends in slash
                    (this._name + '/' + fileName);
            }

            // Get main template file
            inovestor.ms.core.getTemplate(fileCacheKey, filePath).then(function (template) {
                $(plugin.element).html(template);
                plugin.buildCache();
                plugin.bindEvents();
                plugin.render();
                plugin.bindModel();
            }).then(function () {
                // Call Search
                plugin.search(plugin.options.symbol).always(function () {
                    // When search is completed, trigger onReady event
                    plugin.$element.trigger('ready' + '.' + plugin._name);
                });
            });
        },

        // Remove plugin instance completely
        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        // Cache DOM nodes for performance
        buildCache: function () {
            this.$element = $(this.element);
        },

        // Bind events that trigger methods
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('ready' + '.' + plugin._name, function () {
                var onReady = plugin.options.onReady;
                if (typeof onReady === 'function')
                    onReady.call(plugin.$element);
            });
        },

        // Unbind events that trigger methods
        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        // API error handler
        apiErrorHandler: function (apiError) {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.apiError, apiError, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.hasError(true);
        },

        // Invalid Identifier error handler
        invalidIdentifierHandler: function () {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.invalidIdentifier, null, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.isInvalidIdentifier(true);
        },

        // Search for a particular profile
        search: function (symbol) {
            var plugin = this;

            // Make sure required variables are set
            if (inovestor.ms.core.isNullOrUndefined(symbol))
                throw "symbol is required";

            // Update options
            plugin.options.symbol = symbol;

            // Setup API url with term
            var stockProfileUrl = inovestor.ms.core.stringFormat(inovestor.ms.stock.profile.config.apiRelativeUrl, { symbol: symbol });

            // Reset relevant Data before calling API
            plugin._viewModel.profile(null);
            plugin._viewModel.chosenYear(null);
            plugin._viewModel.hasError(false);
            plugin._viewModel.isInvalidIdentifier(false);

            // Call API and bind model
            var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } };
            return inovestor.ms.core.ajaxApi(stockProfileUrl, options).then(function (data) {
                if (!inovestor.ms.core.isNullOrUndefined(data)) {
                    if (data.requestStatus === 'invalidIdentifier')
                        plugin.invalidIdentifierHandler();

                    plugin._viewModel.profile(data);
                    if (plugin._viewModel.profile().yearlyCompensations.length > 0) {
                        plugin._viewModel.chosenYear(plugin._viewModel.profile().yearlyCompensations[0].year);
                    }
                    plugin._renderRevenueChart();
                    plugin._replaceOrder();
                    plugin._bindTemplateEvents();
                }

                plugin.update();
            });
        },

        // Renders html template and binds model (should be called once)
        render: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
        },

        //Render bar chart for employees' revenues
        _renderRevenueChart: function () {
            var plugin = this;
            var data = [];
            var elements = plugin.$element.find('.revenueChart');
            var l = elements.length;
            for (var i = 0; i < l; i++) {
                var $element = $(elements[i]);
                salary = parseInt($element.attr("salary"));
                bonus = parseInt($element.attr("bonus"));
                other = parseInt($element.attr("other"));
                total = bonus + salary + other;

                $element.highcharts({
                    chart: {
                        type: 'bar',
                        height: 10,
                        margin: [0, 0, 0, 0]
                    },
                    tooltip: {
                        enabled: false
                    },
                    legend: {
                        enabled: false
                    },
                    title: {
                        text: ""
                    },
                    xAxis: {
                        visible: false
                    },
                    yAxis: {
                        max: 1,
                        visible: false
                    },
                    credits: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            stacking: 'normal'
                        }
                    },
                    series: [
                        { name: "Other", data: [other / total] },
                        { name: "Bonus", data: [bonus / total] },
                        { name: "Salary", data: [salary / total] }]
                });
            };
        },

        _replaceOrder: function () {
            var plugin = this;
            //Replacing \n in principal shareholders
            var content = plugin.$element.find('.shareholders p').text();
            $('.shareholders p').html(content.replace(/\n/g, '<br />'));
        },

        _bindTemplateEvents: function () {
            var plugin = this;
            // Must call the redraw Highchart event when switching from Year to Year
            plugin.$element.find('input[name="years"]').on('change' + '.' + plugin._name, function () {
                var value = parseInt($(this).val());
                if (!inovestor.ms.core.isNullOrUndefined(value) && !isNaN(value)) {
                    plugin._viewModel.chosenYear(value);
                    var elements = plugin.$element.find('.revenueChart');
                    var l = elements.length;
                    for (var i = 0; i < l; i++) {
                        $(elements[i]).highcharts().reflow();
                    };
                }
            });
        },

        // Update resources
        update: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
            //plugin._renderRevenueChart();
            plugin._viewModel.chosenYear.valueHasMutated();
        },

        // Applies knockout bindings to element. (Should be done only once)
        bindModel: function () {
            var plugin = this;
            ko.applyBindings(plugin._viewModel, plugin.element);
        },
    });

    // JQuery Plugin wrapper
    $.fn.inoMsStockProfile = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };

    // Default options for plugin
    $.fn.inoMsStockProfile.defaults = {
        symbol: null,
        onError: null,
        onReady: null,
        templatePaths: {
            profile: null
        }
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function (stock, undefined) {
    stock.profile.resources = stock.profile.resources || {};
    stock.profile.resources["en"] = {
        activity: "Activity",
        address: "Address",
        auditors: "Auditors",
        bonus: "Bonus",
        chiefExecutiveOfficer: "Chief Executive Officer",
        chiefTechnology: "Chief Technology and Operations Officer",
        fax: "Fax",
        fiscalYearEnd: "Fiscal Year End",
        groupHead: "Group Head, Capital Markets",
        indexMembership: "Index Membership",
        industry: "Industry",
        noDataFound: 'No data to display.',
        numberOfEmployees: "Number of employees",
        officersnExecutives: "Officers and Executives",
        other: "Other",
        otherTickers: "Other Ticker(s)",
        principalShareholders: "Principal Shareholders",
        reportingCurrency: "Reporting Currency",
        rntAgents: "R & T Agents",
        salary: "Salary",
        sector: "Sector",
        telephone: "Phone",
        total: "Total",
        website: "Web Site"
    };
})(inovestor.ms.stock);

; (function (stock, undefined) {
    stock.profile.resources = stock.profile.resources || {};
    stock.profile.resources["fr"] = {
        activity: "Activité",
        address: "Adresse",
        auditors: "Auditeurs",
        bonus: "Bonus",
        chiefExecutiveOfficer: "PDG",
        chiefTechnology: "Directeur des Technologies et Opérations",
        fax: "Télécopieur",
        fiscalYearEnd: "Fin d'année fiscale",
        groupHead: "Directeur Marchés des Capitaux",
        indexMembership: "Membre des indices",
        industry: "Industrie",
        noDataFound: 'Aucune donnée à afficher.',
        numberOfEmployees: "Nombre d'employés",
        officersnExecutives: "Dirigeants",
        other: "Autre",
        otherTickers: "Autres symboles boursiers",
        principalShareholders: "Principaux actionnaires",
        reportingCurrency: "Devise des états financiers",
        rntAgents: "Agent des transferts et agent comptable des registres",
        salary: "Salaire",
        sector: "Secteur",
        telephone: "Téléphone",
        total: "Total",
        website: "Site Web"
    };
})(inovestor.ms.stock);
